import { useCreateTeamMutation } from './__generated__/mutations.generated';

function useCreateTeam() {
  const [createTeam, { loading }] = useCreateTeamMutation({
    refetchQueries: ['Teams'],
    awaitRefetchQueries: true,
  });

  return { createTeam, loading };
}

export default useCreateTeam;
